var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-box-container",
      attrs: { id: _vm.claim.id },
      on: {
        mouseup: function($event) {
          _vm.$_can("claims.show") || _vm.$_can("claims.view-own")
        }
      }
    },
    [
      _vm.claimLoading
        ? [_vm._m(0)]
        : [
            _c(
              "router-link",
              {
                attrs: {
                  to: { name: "ClaimsEdit", params: { id: "" + _vm.claim.id } }
                }
              },
              [
                _c("div", { staticClass: "d-flex list-box-header col-12" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "list-box-header-left-no-justify col-lg-8 col-md-8"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pl-0 d-flex align-items-center col-lg-2 col-3 pointer",
                          on: {
                            mousemove: function($event) {
                              _vm.visible = true
                            },
                            mouseleave: function($event) {
                              _vm.visible = false
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "list-box-status align-items-start"
                            },
                            [
                              _c("span", { staticClass: "ref-id pointer" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.claim.ref_id) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.claim.status
                                ? [
                                    _vm.claim.status === "New"
                                      ? _c(
                                          "span",
                                          { class: "btn-status btn-new" },
                                          [_vm._v(_vm._s(_vm.claim.status))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.claim.status === "Active"
                                      ? _c(
                                          "span",
                                          { class: "btn-status btn-active" },
                                          [_vm._v(_vm._s(_vm.claim.status))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.claim.status === "Closed"
                                      ? _c(
                                          "span",
                                          { class: "btn-status btn-closed" },
                                          [_vm._v(_vm._s(_vm.claim.status))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.claim.status === "Reopened"
                                      ? _c(
                                          "span",
                                          { class: "btn-status btn-active" },
                                          [_vm._v(_vm._s(_vm.claim.status))]
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.visible
                            ? _c("i", {
                                staticClass:
                                  "fa fa-copy list-box-icon copy-icon pointer",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    _vm.copyToClipboard(
                                      _vm.claim.ref_id,
                                      "Successfully copied to clipboard"
                                    )
                                  },
                                  mousemove: function($event) {
                                    _vm.visible = true
                                  },
                                  mouseleave: function($event) {
                                    _vm.visible = false
                                  }
                                }
                              })
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center col-lg-4 col-8 wrap pointer"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.claim.customer.name) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center claim-move-date col-3 company-wrap wrap pointer"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "claim-moving-company pr-4" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.claim.company) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("label"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center claim-move-date company-wrap pl-3 col-2 wrap pointer"
                        },
                        [
                          _c("customTooltip", {
                            attrs: { config: { placement: "top" } },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var isOpen = ref.isOpen
                                  var open = ref.open
                                  var close = ref.close
                                  return _c(
                                    "div",
                                    {
                                      on: { mouseover: open, mouseleave: close }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { attrs: { "data-trigger": "" } },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.claim.date) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: isOpen,
                                              expression: "isOpen"
                                            }
                                          ],
                                          staticClass: "custom-tooltip",
                                          attrs: { "data-popper": "" }
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "border-black",
                                            attrs: { "x-arrow": "" }
                                          }),
                                          _vm._v(
                                            "\n                  Created date\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center col-2 pr-4 wrap pointer"
                        },
                        [
                          _c("label"),
                          _vm._v(" "),
                          _c("customTooltip", {
                            attrs: { config: { placement: "top" } },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var isOpen = ref.isOpen
                                  var open = ref.open
                                  var close = ref.close
                                  return _c(
                                    "div",
                                    {
                                      on: { mouseover: open, mouseleave: close }
                                    },
                                    [
                                      _vm.claim.cluster_user
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "claim-agent",
                                              attrs: { "data-trigger": "" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.claim.cluster_user
                                                      .username
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass: "claim-agent",
                                              attrs: { "data-trigger": "" }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-exclamation-circle unassigned-icon"
                                              }),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "\n                    Unassigned\n                  "
                                                )
                                              ])
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: isOpen,
                                              expression: "isOpen"
                                            }
                                          ],
                                          staticClass: "custom-tooltip",
                                          attrs: { "data-popper": "" }
                                        },
                                        [
                                          _c("div", {
                                            staticClass: "border-black",
                                            attrs: { "x-arrow": "" }
                                          }),
                                          _vm._v(
                                            "\n                  Assignee\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "list-box-header-right col-4" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "list-box-header-options justify-content-end col-12"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center wrap pointer"
                          },
                          [
                            _c("div", { staticClass: "claim-trucks-movers" }, [
                              _c("i", {
                                staticClass: "fa fa-user list-box-icon"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "price-value pr-2" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.claim.movers) +
                                    "\n                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-truck list-box-icon"
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "price-value" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.claim.trucks) +
                                    "\n                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("label"),
                            _vm._v(" "),
                            _c("customTooltip", {
                              attrs: { config: { placement: "top" } },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var isOpen = ref.isOpen
                                    var open = ref.open
                                    var close = ref.close
                                    return _c(
                                      "div",
                                      {
                                        on: {
                                          mouseover: open,
                                          mouseleave: close
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "price pl-3 pr-4",
                                            attrs: { "data-trigger": "" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                    $" +
                                                _vm._s(_vm.claim.total_price) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: isOpen,
                                                expression: "isOpen"
                                              }
                                            ],
                                            staticClass: "custom-tooltip",
                                            attrs: { "data-popper": "" }
                                          },
                                          [
                                            _c("div", {
                                              staticClass: "border-black",
                                              attrs: { "x-arrow": "" }
                                            }),
                                            _vm._v(
                                              "\n                    Total move price\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "options" }, [
                          _c("div", { staticClass: "options-buttons" }, [
                            _c(
                              "div",
                              {
                                staticClass: "dropdown",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                  }
                                }
                              },
                              [
                                _c("button", {
                                  staticClass: "btn btn-secondary add-filter",
                                  attrs: {
                                    type: "button",
                                    id: "dropdownMenuButton",
                                    "data-toggle": "dropdown",
                                    "aria-haspopup": "true",
                                    "aria-expanded": "false"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right",
                                    attrs: {
                                      "aria-labelledby": "dropdownMenuButton"
                                    }
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "dropdown-item nav-link btn",
                                        on: { click: _vm.assignClaim }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      Assign user\n                    "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.claim.status !== "Closed"
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "dropdown-item nav-link btn",
                                            on: {
                                              click: function($event) {
                                                _vm.claimClose = true
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                      Close claim\n                    "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary expand-claims",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    $event.stopPropagation()
                                    _vm.toggleClaim(_vm.claim.id)
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-caret-down caret",
                                  class: {
                                    rotate: _vm.expanded.includes(_vm.claim.id)
                                  }
                                })
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("hr", {
              class: [
                _vm.expanded.includes(_vm.claim.id) ? "w-100 divider" : "hidden"
              ]
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex flex-column",
                class: [
                  _vm.expanded.includes(_vm.claim.id)
                    ? "list-box-expanded"
                    : "hidden"
                ]
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex col-12 p-0" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column justify-content-start col-lg-3 contact-info-wrap"
                      },
                      [
                        _c("div", { staticClass: "contact-info mb-4" }, [
                          _c("span", { staticClass: "claim-heading pb-2" }, [
                            _vm._v("\n              Contact info\n            ")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "email" }, [
                            _c("i", { staticClass: "fa fa-at list-box-icon" }),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.claim.customer.email) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "phone" }, [
                            _c("i", {
                              staticClass: "fa fa-phone list-box-icon"
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.phoneMask.maskedPhone(
                                    _vm.claim.customer.phone
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column justify-content-start col-lg-5 col-6"
                      },
                      [
                        _c("div", { staticClass: "list-box-info mb-4" }, [
                          _c("span", { staticClass: "claim-title pb-1" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.claim.title) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.claim.description) +
                                "\n            "
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column justify-content-start col-lg-1 col-6 pl-2"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "list-box-info mb-4" },
                          [
                            _c("span", { staticClass: "claim-heading pb-1" }, [
                              _vm._v("\n              Move date\n            ")
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.claim.move_date) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.$_can("tags.show")
                              ? [
                                  _c(
                                    "span",
                                    { staticClass: "claim-heading pt-3" },
                                    [
                                      _vm._v(
                                        "\n                Tags\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-start flex-wrap pt-2"
                                    },
                                    _vm._l(_vm.claim.tags, function(tag) {
                                      return _c("tag-color", {
                                        key: tag.id,
                                        attrs: {
                                          color: tag.color.name,
                                          name: tag.name,
                                          "input-class": "mr-1"
                                        }
                                      })
                                    })
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("ClaimsBlockSettlementAmount", {
                      attrs: { claim: _vm.claim },
                      on: {
                        update: function($event) {
                          _vm.$emit("getClaims")
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "claim-expanded-mobile col-12 mobileshow pl-0"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex-column justify-content-start col-6"
                      },
                      [
                        _c("div", { staticClass: "list-box-info mb-4" }, [
                          _c("span", { staticClass: "claim-heading pb-1" }, [
                            _vm._v("\n              Assigned to\n            ")
                          ]),
                          _vm._v(" "),
                          _vm.claim.cluster_user
                            ? _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.claim.cluster_user.name) +
                                    "\n            "
                                )
                              ])
                            : _c("span", [
                                _vm._v("\n              System\n            ")
                              ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "claim-heading pt-3" }, [
                            _vm._v("\n              Created by\n            ")
                          ]),
                          _vm._v(" "),
                          _vm.claim.created_by
                            ? _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.claim.created_by.first_name) +
                                    " " +
                                    _vm._s(_vm.claim.created_by.last_name) +
                                    "\n            "
                                )
                              ])
                            : _c("span", [
                                _vm._v("\n              System\n            ")
                              ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "claim-heading pt-3" }, [
                            _vm._v("\n              Move date\n            ")
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.claim.move_date) +
                                "\n            "
                            )
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column justify-content-start col-6"
                      },
                      [
                        _c("div", { staticClass: "list-box-info mb-4" }, [
                          _c("span", { staticClass: "claim-heading pb-1" }, [
                            _vm._v("\n              Company\n            ")
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.claim.company) +
                                "\n            "
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.claim.status === "Closed"
                  ? _c(
                      "div",
                      { staticClass: "d-flex justify-content-start col-12" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "claim-closed justify-content-between col-lg-5 col-12"
                          },
                          [
                            _c("div", { staticClass: "d-flex mb-2 pr-3" }, [
                              _c("p", [
                                _vm._v("Claim closed with resolution "),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.claim.claim_resolution))
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex pointer justify-content-end",
                                on: { click: _vm.reopenClaim }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-repeat reopen-ico pr-2"
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "reopen-text" }, [
                                  _vm._v("Reopen claim")
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.claimClose
              ? _c(
                  "modal",
                  {
                    attrs: { size: "modal-large", "close-strict": true },
                    on: {
                      close: function($event) {
                        _vm.claimClose = false
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("h4", [
                        _vm._v(_vm._s(_vm.claim.ref_id) + " - Close claim")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "body" }, slot: "body" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Select a resolution")]),
                            _vm._v(" "),
                            _vm.claim
                              ? _c("simple-select", {
                                  attrs: { options: _vm.claimResolutions },
                                  model: {
                                    value: _vm.claim_resolution_id,
                                    callback: function($$v) {
                                      _vm.claim_resolution_id = $$v
                                    },
                                    expression: "claim_resolution_id"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "claim_resolution_id"
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "select-wrap h-auto mt-3" }, [
                          _c("label", [_vm._v("Enter a note")]),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.note,
                                expression: "note"
                              }
                            ],
                            staticClass: "select-wrap-textarea form-control",
                            attrs: { rows: "5", required: "" },
                            domProps: { value: _vm.note },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.note = $event.target.value
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: { errors: _vm.errors, field: "note" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12 text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  _vm.claimClose = false
                                }
                              }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: {
                                type: "button",
                                disabled: _vm.formInvalid
                              },
                              on: { click: _vm.claimResolution }
                            },
                            [_vm._v("Close claim")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showAssignClaim
              ? _c(
                  "modal",
                  {
                    attrs: { size: "modal-large", "close-strict": true },
                    on: {
                      close: function($event) {
                        _vm.showAssignClaim = false
                      }
                    }
                  },
                  [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-10" }, [
                          _c("div", [
                            _c("h4", [
                              _vm._v(
                                _vm._s(_vm.claim.ref_id) + " - Assign claim to"
                              )
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { attrs: { slot: "body" }, slot: "body" },
                      [
                        _c(
                          "div",
                          { staticClass: "select-wrap" },
                          [
                            _c("label", [_vm._v("Select User")]),
                            _vm._v(" "),
                            _c("simple-select", {
                              attrs: { options: _vm.assignees },
                              on: {
                                change: function($event) {
                                  _vm.clearError($event)
                                }
                              },
                              model: {
                                value: _vm.assigneeId,
                                callback: function($$v) {
                                  _vm.assigneeId = $$v
                                },
                                expression: "assigneeId"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("error-field", {
                          attrs: {
                            errors: _vm.errors,
                            field: "cluster_user_id"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary pull-right",
                              attrs: { type: "button" },
                              on: { click: _vm.assign }
                            },
                            [_vm._v("\n              Assign\n            ")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ellipsis px-4 py-4" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7da3ca6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da3ca6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/claims/ClaimBlock.vue
// module id = null
// module chunks = 